import { Story as GenericStory, Meta } from "@storybook/react";
import { Search, SearchIcon } from "lucide-react";
import React from "react";
import { createGlobalStyle } from "styled-components";
import { typographyMixin } from "../../../helpers";
import { noop } from "../../../utils";
import Flex from "../../Flex";
import { Label } from "../../Typography";
import Select, { ISelectProps } from "./Select";

type TArgs = ISelectProps<number, string, string, string>;
type Story = GenericStory<React.ComponentProps<typeof Select>>;

const GlobalStyle = createGlobalStyle`
	body {
		${typographyMixin("paragraph-small-regular")}
	}
`;

const mockOptions = [
    { label: "one", value: 1 },
    { label: "two", value: 2 },
    { label: "three", value: 3 },
    { label: "four", value: 4 },
    { label: "five", value: 5 },
    { label: "six", value: 6 },
    { label: "seven", value: 7 },
    { label: "eight", value: 8 },
    { label: "nine", value: 9 },
    { label: "ten", value: 10 }
];

const commonArgs: TArgs = {
    options: mockOptions,
    trackName: "Stories.Select.TrackEvent",
    noResults: "No results",
    onChange: noop
};

export default {
    title: "Form Components/Select",
    component: Select,
    args: commonArgs
} as Meta;

const Template: Story = args => {
    return (
        <Flex column width={500}>
            <GlobalStyle />
            <Select {...args} />
        </Flex>
    );
};

export const Default = Template.bind({});

export const WithCustomRenderer = Template.bind({});
WithCustomRenderer.args = {
    children: option => (
        <Flex column p={4}>
            <Label size="label-medium-semibold" color="text-primary-600">
                {option.label}
            </Label>
        </Flex>
    )
};

export const WithLabelAndHelperText = Template.bind({});
WithLabelAndHelperText.args = {
    label: "Label",
    helperText: "Helper text"
};

export const WithIcon = Template.bind({});
WithIcon.args = {
    icon: <SearchIcon />,
    placeholder: "Search"
};

export const AsASearchField = Template.bind({});
AsASearchField.args = {
    placeholder: "Search",
    disabled: false,
    withoutArrow: true,
    icon: <Search size={16} />
};

export const WithError = Template.bind({});
WithError.args = {
    error: (
        <>
            Available quantity of Product 1 at BER2: <strong>2000</strong>
        </>
    )
};

export const WithErrorAsBoolean = Template.bind({});
WithErrorAsBoolean.args = {
    error: true
};

export const Disabled = Template.bind({});
Disabled.args = {
    disabled: true
};

export const NotFilterable = Template.bind({});
NotFilterable.args = {
    filterable: false
};

export const WithClearButton = Template.bind({});
WithClearButton.args = {
    withClearButton: true
};
